import { render, staticRenderFns } from "./CustomerAddressListPage.vue?vue&type=template&id=209c9cd6&"
import script from "./CustomerAddressListPage.vue?vue&type=script&lang=ts&"
export * from "./CustomerAddressListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports